<div class="unified-plans-container">
  <!-- Offer Cards - Mobile-first stacked layout -->
  <div class="offers-wrapper" *ngIf="offers">
    <div *ngFor="let offer of offers; trackBy: trackById" class="offer-wrapper">
      <flo-offer-selection-card
        [offer]="offer"
        [isSelected]="selectedOffer?.id === offer.id"
        [forceVerticalLayout]="true"
        (click)="onOfferClick(offer)"
        data-test="unified-offer-card"
      ></flo-offer-selection-card>
    </div>
  </div>

  <!-- Value Props Section -->
  <div class="value-props-section" *ngIf="valueProps && valueProps.length > 0">
    <h4 class="value-props-title">Included with the Selected Plan</h4>
    <div class="value-props-list">
      <flo-value-prop
        *ngFor="let valueProp of valueProps; trackBy: trackById"
        [proposition]="valueProp.text || valueProp"
        [label]="valueProp.style === 'checkmark' ? 'checkmark-green' : valueProp.style"
        svgWidth="18"
        data-test="unified-value-prop"
      ></flo-value-prop>
    </div>
  </div>
</div>
